import { DEFAULT_METRIC_TEMPLATES } from '@griply/utils';

import {
  RemoteAppConfig,
  RemoteAppConfigKeys,
} from './remote-app-config-types';

export const remoteAppConfigDefaults: RemoteAppConfig = {
  [RemoteAppConfigKeys.GoalMetricTemplates]: JSON.stringify(
    DEFAULT_METRIC_TEMPLATES,
  ),
};
